import { Pipe, PipeTransform } from '@angular/core';
import { CheckCircle, CrossCircle, PHX_CHECKBOX_STATES, SubtractCircle } from 'phx-core';

@Pipe({
  name: 'checkboxIcon',
})
export class CheckboxIcon implements PipeTransform {
  transform(value: PHX_CHECKBOX_STATES | boolean): string {
    if (value === PHX_CHECKBOX_STATES.ON || value === true) return CheckCircle;
    else if (value === PHX_CHECKBOX_STATES.OFF || value === false) return CrossCircle;
    else if (value === PHX_CHECKBOX_STATES.INDETERMINATE) return SubtractCircle;
    else return null;
  }
}